import { createAction } from '@reduxjs/toolkit'

import { TCustomField } from 'types/GlobalCustomField'

export const getAll = createAction('get_all_custom_fields')
export const getAllSuccess = createAction<TCustomField[]>(
  'get_all_custom_fields_success'
)
export const getAllFailed = createAction('get_all_custom_fields_failed')

export const create = createAction('create_custom_field')
export const createSuccess = createAction<TCustomField>(
  'create_custom_field_success'
)
export const createFailed = createAction('create_custom_field_failed')
